import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'viewport',
  `
    OPEN_NOTIFICATIONS_DROPDOWN
    CLOSE_NOTIFICATIONS_DROPDOWN
  `
);
